// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"43":"c33d6865","46":"aac6abaf","88":"c4f6843e","140":"b48222d6","297":"f062860f","306":"df2f1dc8","438":"ad32cf66","440":"a7aa7af9","541":"02dd8c93","596":"9c23e181","800":"a88baf50","889":"89204cc5","926":"4603f0fd"}[chunkId] + ".js";
};